export default function Icon({icon, spin = false, direction = null}) {
    return(
        <i className={`fi ${icon} ${spin ? "fi-spin" : null} ${direction ? direction : null}`} aria-hidden="true"></i>
    )
}